import standardAPI from '@/api/standard_items';

const state = {
  logs: [],
  logs_status: '',
  logs_MetaData: {},
  logs_page: 1,
  logs_perPage: 50,
};

const responseUrl = '/ms-sitelogger/logs';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_logs ({ commit }, getOptions) {
    commit('LOGS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
      token: getOptions.token,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('LOGS_SUCCESS', response);
            commit('LOGS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('LOGS_READY');
            reject(response);
          } else {
            commit('LOGS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_logs ({ commit, dispatch }, itemData) {
    commit('LOGS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          commit('LOGS_READY');
          resolve(response);
        } else {
          commit('LOGS_READY');
          reject(response);
        }
      });
    });
  },
  edit_logs ({ commit, dispatch }, itemData) {
    commit('LOGS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          commit('LOGS_READY');
          resolve(response);
        } else {
          commit('LOGS_READY');
          reject(response);
        }
      });
    });
  },
  remove_logs ({ commit, dispatch }, itemData) {
    commit('LOGS_REQUEST');
    const preparedData = {
      itemData: itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          commit('LOGS_READY');
          resolve(response);
        } else {
          commit('LOGS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_logs ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData: orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.logs_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.logs_perPage = max;
  },
  LOGS_READY: (state) => {
    state.logs_status = 'ready';
  },
  LOGS_REQUEST: (state) => {
    state.logs_status = 'loading';
  },
  LOGS_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.logs_MetaData.meta = response.meta;
      state.logs_MetaData.links = response.links;
    }
    state.logs = response.data.data;
    state.logs_status = 'success';
  },
  LOGS_ERROR: (state) => {
    state.logs_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
